import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { flexDirectionColumn } from 'shared/styles/commonStyles';




const ITEMS = [
  {
    key: 'ess',
    to: '/ess',
    glyph: '/images/sidebar-ess-glyph.png',
    word: '/images/sidebar-ess-word.png',
    label: 'ESS',
  },
  {
    key: 'tgs',
    to: '/tgs',
    glyph: '/images/sidebar-tgs-glyph.png',
    word: '/images/sidebar-tgs-word.png',
    label: 'TGS',
  },
  {
    key: 'tes',
    to: '/tes',
    glyph: '/images/sidebar-tes-glyph.svg',
    word: '/images/sidebar-tes-word.png',
    label: 'TES',
  },
];

const SwitchNavGroup = ({ disabled = [], handleOnClick }) => {
  return (
    <Wrapper>
      {ITEMS.map((item, index) => {
        const isDisabled = disabled[index];
        return (
          <Item
            key={item.key}
            to={isDisabled ? '#' : item.to}
            $disabled={isDisabled}
            onClick={() => isDisabled || handleOnClick?.('groupB', index)}
          >
            <Glyph src={item.glyph} alt={`${item.label} icon`} />
            <Word src={item.word} alt={item.label} />
          </Item>
        );
      })}
    </Wrapper>
  );
};

export default SwitchNavGroup;

const Wrapper = styled.div`
  ${flexDirectionColumn};
  align-items: center;
  gap: 20px;
  padding: 4px 0;
  margin-bottom: 2rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

const Item = styled(NavLink)`
  position: relative;
  width: 44px;
  height: 44px;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  border: 0.8px solid transparent;
  transition: background 120ms ease, border-color 120ms ease,
    box-shadow 120ms ease, transform 120ms ease;

  &.active {
    background: rgba(43, 127, 255, 0.1);
    border-color: rgba(43, 127, 255, 0.4);
    box-shadow: 0px 2px 10px rgba(43, 127, 255, 0.45);
  }

  &.active::before {
    content: '';
    position: absolute;
    left: -11px;
    top: 11px;
    width: 3px;
    height: 22px;
    border-radius: 0 26px 26px 0;
    background: #2b7fff;
    box-shadow: 0px 0px 8px rgba(43, 127, 255, 0.45);
  }

  &:hover {
    background: rgba(43, 127, 255, 0.06);
    transform: scale(1.02);
  }

  ${(p) =>
    p.$disabled &&
    css`
      opacity: 0.4;
      cursor: not-allowed;
      pointer-events: none;
    `}
`;

const Glyph = styled.img`
  width: 24px;
  height: 24px;
  object-fit: contain;
`;

const Word = styled.img`
  width: 32px;
  height: 22px;
  object-fit: contain;
`;
